export function getPropertyRateImpressionKey(
  rate: App.EnrichedPropertyRate,
  originAirport: App.Airport | undefined,
): string {
  if (
    rate.includesFlights &&
    typeof rate.cheapestFlightPrice === 'number' &&
    rate.cheapestFlightPrice > 0 &&
    originAirport?.code
  ) {
    return `${rate.rateId}:flight-bundle:${originAirport.code}`
  }

  return `${rate.rateId}:hotel`
}
